// src/views/not-found.js
import React from 'react'
import { Helmet } from 'react-helmet'
import './not-found.css'
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="not-found-page">
      <Helmet>
        <title>404 - Mercadito AI</title>
      </Helmet>

      <div className="not-found-card">
        <div className="not-found-icon-badge">🧭</div>

        <div className="not-found-code-wrapper">
          <span className="not-found-code">404</span>
        </div>

        <h1 className="not-found-title">
          {t('notFound.title', '¡Página no encontrada!')}
        </h1>

        <p className="not-found-subtitle">
          {t(
            'notFound.subTitle',
            'Lo sentimos, pero la página que solicitaste no existe o ha sido movida.'
          )}
        </p>

        <div className="not-found-actions">
          <a className="btn-not-found-primary" href="/">
            <span className="btn-back-icon">←</span>
            <span>{t('notFound.backHome', 'Volver al Inicio')}</span>
          </a>
          <a className="btn-not-found-secondary" href="/dashboard">
            <span>{t('notFound.dashboard', 'Ir al Panel')}</span>
            <span>→</span>
          </a>
        </div>
      </div>
    </div>
  )
}

export default NotFound